import { render } from "./AdminDepartments.vue?vue&type=template&id=5ac53d5a&scoped=true"
import script from "./admindepartments.view.js?vue&type=script&lang=js&external"
export * from "./admindepartments.view.js?vue&type=script&lang=js&external"

import "./admindepartments.css?vue&type=style&index=0&id=5ac53d5a&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac53d5a"]])

export default __exports__